<template>
  <div>
    <div class="columns">
      <div class="column">
        <b-field
          id="nationality"
          :label="$t('kyc.nationality')"
          class="kyc-nationality-is-expanded"
        >
          <b-autocomplete
            v-validate="{ required: true, isNationalityNotAvailable: countries, isNationality: countries }"
            v-model="nationalityInput"
            :data="filteredContries"
            :placeholder="$t('kyc.nationality')"
            field="nationality"
            name="nationality"
            data-test="kyc-nationality--nationality-field"
            autocomplete="disabled"
            open-on-focus
            @select="selectNationality"
            @blur="$emit('trackInputForm', { key: 'nationality', name: 'nationality', page: 'Nationality' })"
          >
            <template slot-scope="props">
              <div :class="[{ 'disabled-country': props.option && props.option.hasOwnProperty('disabled') && props.option.disabled }]">
                {{ `${props.option.nationality} ${props.option.hasOwnProperty('disabled') && props.option.disabled ? '(not available)' : ''}` }}
              </div>
            </template>
            <template slot="empty">
              {{ $t('messages.no_result_found') }}
            </template>
          </b-autocomplete>
        </b-field>
        <span class="is-invalid">{{ errors.first('nationality') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="customer-type"
          :label="$t('kyc.customer_type')"
          class="kyc-nationality-is-expanded"
        >
          <b-select
            v-validate="'required'"
            v-model="form.customerType"
            :placeholder="$t('kyc.select_customer_type')"
            name="customer type"
            data-test="kyc-nationality--customer-type-field"
            @blur="$emit('trackInputForm', { key: 'customerType', name: 'customer type', page: 'Nationality' })"
          >
            <option
              v-for="(option, index) in customerTypeData"
              :value="option.value"
              :key="index">
              {{ option.label }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('customer type') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nationality',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    countries: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      nationalityInput: '',
      customerTypeData: [
        { label: this.$t('kyc.personal'), value: 'Personal' }
        // { label: this.$t('kyc.organization'), value: 'Organization' } // TODO: open coming soon
      ]
    }
  },
  computed: {
    filteredContries () {
      if (this.nationalityInput) {
        return this.countries.filter((option) => {
          return option.nationality.toString().toLowerCase().indexOf(this.nationalityInput.toLowerCase()) >= 0
        })
      }
      return this.countries
    }
  },
  watch: {
    nationalityInput (value) {
      if (this.countries.length) {
        const expectedCountry = this.countries.length && this.countries.find(c => c.nationality.toLowerCase() === value.toLowerCase())
        if (expectedCountry && (!expectedCountry.hasOwnProperty('disabled') || (expectedCountry.hasOwnProperty('disabled') && !expectedCountry.disabled))) {
          this.form.nationality = value
        } else {
          this.form.nationality = ''
        }
      }
    }
  },
  async created () {
    if (this.form.nationality) {
      this.nationalityInput = this.form.nationality
    }
  },
  beforeDestroy () {
    this.$validator.pause()
  },
  methods: {
    selectNationality (option) {
      if (option) {
        this.form.nationality = option.nationality
      } else {
        this.form.nationality = ''
      }
    }
  }
}
</script>

<style lang="scss">
.kyc-nationality-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.disabled-country {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/Nationality.vue